import { fallback as viem_fallback } from 'viem';
import {} from '../createConfig.js';
export function fallback(transports, config) {
    return viem_fallback(transports, config);
}
//# sourceMappingURL=fallback.js.map